{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "予約済み",
      "confirmed": "確認済み",
      "completed": "完了",
      "cancelled": "キャンセル済み",
      "no-show": "受診なし",
      "checked-in": "受付済み"
    },
    "resultStatus": {
      "final": "確定",
      "preliminary": "暫定",
      "corrected": "訂正済み"
    },
    "allergySeverity": {
      "severe": "重度",
      "high": "高度",
      "moderate": "中等度"
    },
    "nationalIdType": {
      "NRIC": "NRIC（シンガポール身分証）",
      "HKID": "HKID（香港身分証）",
      "MyKad": "MyKad（マレーシア身分証）",
      "Aadhaar": "Aadhaar（インド身分証）",
      "KTP": "KTP（インドネシア身分証）",
      "Passport": "パスポート"
    },
    "messageSenderType": {
      "provider": "医療提供者",
      "patient": "患者"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "パスワードが一致しません",
      "passwordMinLength": "パスワードは8文字以上で入力してください"
    }
  },
  "labels": {
    "abnormal": "異常"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "マイヘルス",
        "results": "検査結果",
        "appointments": "予約",
        "messages": "メッセージ",
        "forms": "フォーム"
      },
      "signOut": "サインアウト",
      "signOutAria": "サインアウト",
      "navAria": "ポータルナビゲーション",
      "footer": "VynaEMR 患者ポータル — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "患者ポータル",
      "labels": {
        "email": "メールアドレス",
        "password": "パスワード"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "パスワードを入力"
      },
      "button": {
        "signIn": "サインイン",
        "signingIn": "サインインしています..."
      },
      "toast": {
        "welcome": "おかえりなさい！",
        "invalid": "メールアドレスまたはパスワードが正しくありません"
      },
      "links": {
        "noAccount": "アカウントをお持ちでないですか？",
        "register": "登録"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "おはようございます",
        "afternoon": "こんにちは",
        "evening": "こんばんは",
        "fallbackName": "ようこそ"
      },
      "subtitle": "あなたの健康サマリーをご覧ください。",
      "error": "健康サマリーを読み込めませんでした。しばらくしてから再度お試しください。",
      "demographics": {
        "ageLabel": "{{age}}歳",
        "bloodTypeLabel": "血液型：{{bloodType}}"
      },
      "quickLinks": {
        "results": "検査結果",
        "appointments": "予約",
        "messages": "メッセージ",
        "forms": "フォーム"
      },
      "sections": {
        "allergies": "アレルギー",
        "activeMedications": "服用中の薬",
        "activeProblems": "現在の問題",
        "upcomingAppointments": "今後の予約",
        "recentResults": "最近の結果",
        "immunizations": "予防接種歴",
        "emergencyContact": "緊急連絡先"
      },
      "states": {
        "noAllergies": "登録されているアレルギーはありません。",
        "noMedications": "服用中の薬はありません。",
        "noAppointments": "今後の予約はありません。",
        "noResults": "最近の結果はありません。"
      },
      "moreCount": "他 {{count}} 件",
      "sinceDate": "{{date}} から",
      "doseNumber": "{{number}} 回目",
      "viewAll": "すべて表示",
      "providerTBD": "担当者未定"
    },
    "register": {
      "subtitle": "新規アカウントの作成",
      "labels": {
        "fullName": "氏名",
        "email": "メールアドレス",
        "dateOfBirth": "生年月日",
        "phone": "電話番号",
        "mrn": "MRN（診療録番号）",
        "idType": "身分証の種類",
        "idNumber": "身分証番号",
        "password": "パスワード",
        "confirmPassword": "パスワード（確認用）"
      },
      "placeholders": {
        "fullName": "氏名を入力",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "身分証番号を入力",
        "password": "8文字以上",
        "confirmPassword": "パスワードを再入力",
        "selectIdType": "選択してください..."
      },
      "mrnHint": "診療録に紐付けるには、MRN または身分証番号を入力してください。",
      "button": {
        "createAccount": "アカウントを作成",
        "creatingAccount": "アカウントを作成しています..."
      },
      "toast": {
        "success": "登録が完了しました。サインインしてください。",
        "failure": "登録に失敗しました。もう一度お試しください。"
      },
      "links": {
        "haveAccount": "すでにアカウントをお持ちですか？",
        "signIn": "サインイン"
      },
      "aria": {
        "dateOfBirth": "生年月日"
      }
    },
    "appointments": {
      "title": "予約",
      "subtitle": "予約の確認と管理ができます",
      "error": "予約を読み込めませんでした。しばらくしてから再度お試しください。",
      "sections": {
        "upcoming": "今後の予約",
        "past": "過去の予約"
      },
      "states": {
        "noUpcoming": "今後の予約はありません。",
        "noPast": "過去の予約はありません。"
      },
      "reasonLabel": "理由：{{reason}}",
      "instructionsLabel": "注意事項：{{instructions}}",
      "durationMinutes": "{{minutes}} 分",
      "actions": {
        "cancel": "キャンセル",
        "confirmCancel": "確定",
        "cancelling": "キャンセルしています...",
        "keep": "戻る"
      },
      "toast": {
        "cancelSubmitted": "キャンセル依頼を送信しました。担当チームから確認のご連絡があります。",
        "cancelFailed": "予約のキャンセルに失敗しました。診療所までお電話ください。"
      }
    },
    "results": {
      "title": "検査結果",
      "subtitle": "検査・画像検査の結果をご覧いただけます",
      "error": "結果を読み込めませんでした。しばらくしてから再度お試しください。",
      "referenceRange": "（基準値：{{range}}）",
      "states": {
        "noResults": "ご覧いただける結果はありません。"
      }
    },
    "messages": {
      "title": "メッセージ",
      "subtitle": "担当チームと連絡を取り合うことができます",
      "error": "メッセージを読み込めませんでした。しばらくしてから再度お試しください。",
      "fromSender": "差出人：{{name}}",
      "labels": {
        "subject": "件名",
        "message": "メッセージ",
        "reply": "返信"
      },
      "placeholders": {
        "subject": "メッセージの件名",
        "message": "メッセージを入力してください...",
        "reply": "返信内容を入力してください..."
      },
      "actions": {
        "newMessage": "新規メッセージ",
        "back": "メッセージ一覧へ戻る",
        "sendMessage": "メッセージを送信",
        "sendReply": "返信を送信",
        "sending": "送信しています..."
      },
      "states": {
        "noMessages": "まだメッセージはありません。"
      },
      "thread": {
        "fromSenderWithType": "差出人：{{name}}（{{type}}）"
      },
      "compose": {
        "title": "新規メッセージ",
        "subtitle": "メッセージは担当チームへ送信されます。"
      },
      "toast": {
        "sent": "メッセージを送信しました",
        "sendFailed": "メッセージの送信に失敗しました"
      }
    },
    "forms": {
      "title": "フォーム",
      "subtitle": "必要なフォームとアンケートにご記入ください",
      "error": "フォームを読み込めませんでした。しばらくしてから再度お試しください。",
      "sections": {
        "pending": "未提出",
        "completed": "提出済み"
      },
      "labels": {
        "required": "必須"
      },
      "placeholders": {
        "select": "選択してください..."
      },
      "actions": {
        "fillOut": "記入する",
        "back": "フォーム一覧へ戻る",
        "submit": "フォームを送信",
        "submitting": "送信しています..."
      },
      "states": {
        "noPending": "未提出のフォームはありません。",
        "noCompleted": "提出済みのフォームはありません。",
        "noFields": "このフォームには記入する項目がありません。"
      },
      "toast": {
        "submitted": "フォームを送信しました",
        "submitFailed": "フォームの送信に失敗しました"
      }
    }
  }
}
